import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DoctorProfileComponent } from './doctor-profile.component';

@NgModule({
  imports: [CommonModule],
  declarations: [DoctorProfileComponent],
  exports: [DoctorProfileComponent],
})
export class DoctorProfileModule {}
